import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { AiOutlineUser } from 'react-icons/ai';
import React, { useEffect, useRef, useState } from 'react';
import style from './header.module.css';
import {
    clickHideAtom,
    logInfoAtom,
    showLoginAtom,
    userPermissionAtom,
    groupInfoAtom,
    showHistoryAtom,
    openPaymentInfoAtom,
    subscriptionsInfoAtom,
    initialLoginStageAtom,
    chatLangAtom,
    balanceAtom,
    // isSmallScreenAtom
} from '../../store';
import { UserPopup } from './UserPopup';
import wallet from '../../assets/wallet.png'
import groupWalletimg from '../../assets/groupWallet.png'
import discordIcon from '../../assets/discord.png'
import RechargePopup from './RechargePopup';
import HistoryPopup from './HistoryPopup'
import { isSafariBrowser } from '../../utils/format'
import { AvatarImage } from '../../common/AvatarImage';
import { SubscribeButton } from '../Subscribe';
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { Plugin } from '../../common/PlugIn';
import ReactGA from "react-ga4";
import { useLocation } from 'react-router-dom';
// import { FiChevronUp } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import Restricted from "../../utils/restricted";
import eventBus from '../../common/MeshEditorJumper/eventBus';
// import UnlimitButton from '../Promotional/UnlimitButton/unlimitbotton'
import { ApiDashboardHeaderButton } from '../ApiDashboard';
import { ErrorPage } from "../ErrorPage";
import { interfaceLangAtom } from "../../store/appStore";
import { DEFAULT_LANG } from "../../utils/seo/utils";
import * as Sentry from "@sentry/react";
import { NewUserPromotionButton } from '../Promotional/NewUserPromotion';


const GroupBalanceComponent = React.forwardRef(({ setShowUser }, ref) => {
    const balance = useRecoilValue(balanceAtom);
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const groupInfo = useRecoilValue(groupInfoAtom);
    const location = useLocation();
    const groupbalanceRef = useRef(null);
    const handleGroupBalanceClick = (event) => {
        ReactGA.event(
            {
                category: 'ui_click',
                action: 'open_group_balance',
                label: 'header'
            }
        )
        if (groupInfo) {
            setShowUser(false)
            if (groupbalanceRef.current && groupbalanceRef.current.contains(event.target)) return
            setOpenPaymentInfo({
                ...openPaymentInfo,
                group: true,
                balance: '',
                step: 1,
                state: true
            })
        }
    }


    return (
        <div
            className={`${style.balance} bg-[var(--balanceBg)] text-[var(--balanceColor)]`}
            ref={ref}
            onMouseEnter={handleGroupBalanceClick}
            onMouseLeave={() => {
                setOpenPaymentInfo({
                    ...openPaymentInfo,
                    state: false
                })
            }}
        >
            <img src={groupWalletimg} alt="groupWalletimg" />
            <div>{balance.groupBalance / 10}</div>
            <div id="rechargeGroup" className={`${style.groupContainer}  ${openPaymentInfo.state && openPaymentInfo.group ? style.show : style.hide}`}>
                <RechargePopup ref={groupbalanceRef} />
            </div>
        </div>
    )
})
GroupBalanceComponent.displayName = 'GroupBalanceComponent'



const SelfBalanceComponent = React.forwardRef(({ setShowUser }, ref) => {
    const balance = useRecoilValue(balanceAtom);
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const balanceRef = useRef(null);
    const logInfo = useRecoilValue(logInfoAtom);
    const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
    const location = useLocation();
    const { t } = useTranslation();

    const handleBalanceClick = (event) => {
        _czc.push([
            '_trackEvent',
            'Index',
            'Balance',
            'Header Component',
        ]);
        _czc.push([
            '_trackPageview',
            '/header/balance',
            window.location.href,
        ]);
        ReactGA.event(
            {
                category: 'ui_click',
                action: 'open_balance',
                label: 'header'
            }
        )
        if (logInfo) {
            setShowUser(false)
            if (balanceRef.current && balanceRef.current.contains(event.target)) return
            setOpenPaymentInfo({
                ...openPaymentInfo,
                group: false,
                balance: '',
                step: 1,
                state: true
            })
        }
    };

    return (
        <div
            className={`${style.balance} bg-[var(--balanceBg)] text-[var(--balanceColor)]`}
            ref={ref}
            onMouseEnter={handleBalanceClick}
            onMouseLeave={() => {
                setOpenPaymentInfo({
                    ...openPaymentInfo,
                    state: false
                })
            }}
        >
            <img src={wallet} alt='wallet' />
            <div className={style.balanceInfo}>
                <span>
                    {
                        (() => {
                            // 防止 undefined 导致 NaN
                            const selfBalance = balance.selfBalance || 0;
                            const walletBalance = subscriptionsInfo.wallet_balance || 0;
                            const totalBalance = selfBalance + walletBalance;
                            return totalBalance > 4000000 ? 'Unlimited' : totalBalance / 10;
                        })()
                    }
                </span>
                <HiOutlineExclamationCircle className={style.icon} fontSize='18' />
            </div>
            <div id="rechargeSelf" className={`${style.userContainer} ${openPaymentInfo.state && !openPaymentInfo.group ? style.show : style.hide}`}>
                <RechargePopup ref={balanceRef} />
            </div>
            <div className={style.balanceDetail}>
                {t('WALLET_SELF_BALANCE_DETAIL')}:&nbsp;<span>
                    {(subscriptionsInfo.wallet_balance || 0) / 10 >= 4000000 ? 'Unlimited' : (subscriptionsInfo.wallet_balance || 0) / 10}
                </span>
            </div>
        </div>
    )
})
SelfBalanceComponent.displayName = 'SelfBalanceComponent'



const AvatarBoxComponent = React.forwardRef(({ showUser, setShowUser }, ref) => {
    const logInfo = useRecoilValue(logInfoAtom);
    const userPopupRef = useRef(null);
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const setShowLogin = useSetRecoilState(showLoginAtom);
    const setInitialLoginStage = useSetRecoilState(initialLoginStageAtom);
    const [avatarUrl, setAvatarUrl] = useState('../../assets/defaultAvatar.png')
    const { t } = useTranslation();

    if (location.pathname.startsWith("/signup")) {
        setShowLogin(true);
        setInitialLoginStage(1);
    }

    if (location.pathname.startsWith("/user/login")) {
        setShowLogin(true);
        setInitialLoginStage(0);
    }

    useEffect(() => {
        setAvatarUrl(logInfo.avatar_url)
    }, [logInfo]);

    const handleAvatarClick = (event) => {
        _czc.push(['_trackEvent', 'Index', 'User Avatar', 'Header Component',]);
        if (logInfo) {
            setOpenPaymentInfo({
                ...openPaymentInfo,
                state: false
            })
            if (userPopupRef.current && userPopupRef.current.contains(event.target)) return
            setShowUser(true);
            _czc.push(['_trackPageview', '/header/panel', window.location.href]);
            ReactGA.event(
                {
                    category: 'ui_click',
                    action: 'open_header_panel',
                    label: 'header'
                }
            )
        } else {
            setShowLogin(true);
            _czc.push(['_trackPageview', '/header/login', window.location.href]);
            ReactGA.event(
                {
                    category: 'ui_click',
                    action: 'login',
                    label: 'header'
                }
            )
        }
    };

    return (
        <div
            className={style.avatarContainer}
            ref={ref}
        >
            <div className={style.avatar} data-cy="header-login-symbol">
                {logInfo ? (
                    <div className='hover:after:content-[""] hover:after:absolute hover:after:right-[0] hover:after:w-[16rem] hover:after:h-16 hover:after:top-12' onMouseEnter={handleAvatarClick} onMouseLeave={() => {
                        setShowUser(false);
                    }}>
                        <AvatarImage url={avatarUrl} />
                        <UserPopup
                            ref={userPopupRef}
                            className={`${showUser ? 'show' : ''} fade`}
                            userInfo={logInfo}
                            setShowUser={setShowUser}
                        />
                    </div>
                ) : (
                    <div
                        data-cy="header-login"
                        onClick={handleAvatarClick}
                    >
                        <AiOutlineUser size="1em" />
                        {' '}
                        &nbsp; {!logInfo && localStorage.getItem('user_uuid') ? t('SETTINGS_LOGIN_INIT_LOADING') : t('SETTINGS_LOGIN_INIT')}
                    </div>
                )}
            </div>
        </div>
    )
})
AvatarBoxComponent.displayName = 'AvatarBoxComponent'



function Header() {
    const logInfo = useRecoilValue(logInfoAtom);
    const location = useLocation();
    const showHistory = useRecoilValue(showHistoryAtom);
    const [showUser, setShowUser] = useState(false);
    const [, setChatLang] = useRecoilState(chatLangAtom);
    const [interfaceLang, setInterfaceLang] = useRecoilState(interfaceLangAtom);
    // const [i18nChange,setI18nChange]=useState(localStorage.getItem('defaultI18n')?localStorage.getItem('defaultI18n'):'en')
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const [openLang, setOpenLang] = useState(false);
    const wrapperRef = [useRef(null), useRef(null), useRef(null), useRef(null)];
    const clickHide = useRecoilValue(clickHideAtom);
    const userPermission = useRecoilValue(userPermissionAtom);
    const { i18n } = useTranslation();
    const [isSafari,] = useState(isSafariBrowser())

    const LangMap = [
        {
            lang: "en",
            name: "EN"
        },
        {
            lang: "zh",
            name: "中文"
        },
        {
            lang: "de",
            name: "Dt"
        },
        {
            lang: "ja",
            name: "日本語"
        },
        {
            lang: "ko",
            name: "한국어"
        },
    ]

    // useEffect(() => {
    //     localStorage.setItem('chatLang', chatLang)
    //     // localStorage.setItem('defaultI18n', chatLang)
    // }, [chatLang])

    const switchLang = (item) => {
        setChatLang('English')
        setInterfaceLang(item)
        if (item === 'en') {
            i18n.changeLanguage("en")
        } else if (item === 'zh') {
            i18n.changeLanguage("zh")
            setChatLang('Chinese')
        } else if (item === 'de') {
            i18n.changeLanguage("de")
        }
        else if (item === 'ja') {
            i18n.changeLanguage("ja")
        }
        else if (item === 'ko') {
            i18n.changeLanguage("ko")
        }

        const url = new URL(window.location.href)
        if (item !== DEFAULT_LANG) {
            url.searchParams.set('lang', item)
        } else {
            url.searchParams.delete('lang')
        }
        window.history.replaceState(null, '', url)
        localStorage.setItem('defaultI18n', item)
        eventBus.emit('languageChanged', item, true);

        setOpenLang(false)
        // if (chatLang === 'Chinese') {
        //     i18n.changeLanguage("en")
        //     setChatLang('English')
        // } else if (chatLang === 'English') {
        //     i18n.changeLanguage("zh")
        //     setChatLang('Chinese')
        // }
    }

    useEffect(() => {
        if (interfaceLang) switchLang(interfaceLang)
    }, [interfaceLang]);

    useEffect(() => {
        const clickOutSide = (event) => {
            if ((wrapperRef[0].current?.contains(event.target))
                || (wrapperRef[1].current?.contains(event.target))
                || (wrapperRef[2].current?.contains(event.target))) return
            setShowUser(false)
            setOpenPaymentInfo({
                ...openPaymentInfo,
                state: false
            })
        }
        document.addEventListener('pointerdown', clickOutSide)
        return () => {
            document.removeEventListener('pointerdown', clickOutSide)
        }
    }, [])
    
    const needFixed = ['/payment', '/error', '/omnicraft/', '/omnicraft', '/omnicraft/viewer', '/MeshEditor', '/omnicraft/hdri', '/omnicraft/search', '/omnicraft/mesh', '/omnicraft/formatcon', '/omnicraft/material', '/omnicraft/texture'].includes(location.pathname)

    const shouldHide = JSON.parse(sessionStorage.getItem('SculptGLInfo'))?.type !== 'omnicraft' && location.pathname.indexOf('/MeshEditor') >= 0

    return (
        <>
            <header style={{
                position: needFixed ? 'fixed' : "",
                top: needFixed ? 0 : "",
                zIndex: needFixed ? 1000 : "",
                left: needFixed ? 0 : "",
                display: shouldHide ? 'none' : 'flex'
            }} className={`${style.con} ${clickHide ? style.conHide : ''}`}>
                <div className={style.header}>
                    {/* <div className={`${style.titleWrapper}  mr-2 sm:mr-4`}> */}
                        {/* <Restricted to="logo.header.view">
                            <div className={style.title}>HYPERHUMAN</div>
                        </Restricted> */}
                        {/* <img className='h-[18px] sm:h-[20px] md:h-[24px] w-auto' src={`${process.env.PUBLIC_URL}/assets/HYPER3D.AI.png`} alt="HYPER3D.AI" /> */}
                        {/* <img className='h-[18px] sm:h-[20px] lg:h-[24px] w-auto' src={demo3} alt="HYPER3D.AI" /> */}
                    {/* </div> */}
                    <Sentry.ErrorBoundary
                        fallback={({ error, resetError }) => (
                            <ErrorPage
                                errorMessage={error?.message}
                                resetError={resetError}
                            />
                        )}>
                        <Restricted to="links.header.view">
                            <>
                                <div className='mr-auto flex flex-row items-center gap-[10px]'>
                                    <SubscribeButton />
                                    <NewUserPromotionButton />
                                </div>
                                <ApiDashboardHeaderButton />
                                <div id='disCheck'>
                                    <span className={style.discordWrapper}>
                                        <a
                                            href='https://discord.com/invite/AhYWCT8WNH'
                                            rel="noreferrer" target="_blank"
                                            className={style.discordLink} >
                                            <img src={discordIcon} alt="discordIcon" />
                                            {/* <span className={style.discordText}>Discord</span> */}
                                        </a>
                                    </span>
                                </div>
                                {(location.pathname.includes('/chatavatar') || location.pathname.includes('/imageto3d')) && <Plugin type="header" />}

                            </>
                        </Restricted>

                        <div className={style.userInfo} id='userInfoCheck'>
                            <Restricted to="wallet.header.view">
                                {logInfo ? (
                                    <>
                                        {userPermission.chatavatar_tab_group && (
                                            <GroupBalanceComponent
                                                ref={wrapperRef[0]}
                                                setShowUser={setShowUser} />
                                        )}
                                        <SelfBalanceComponent
                                            ref={wrapperRef[1]}
                                            setShowUser={setShowUser} />
                                    </>
                                ) : null}
                            </Restricted>
                            <Restricted to="user.header.view">
                                <AvatarBoxComponent
                                    ref={wrapperRef[2]}
                                    showUser={showUser}
                                    setShowUser={setShowUser} />
                            </Restricted>
                            <Restricted to="header.translate.view">
                                <div onMouseLeave={() => { setOpenLang(false) }} className={`group ml-4 relative flex items-center justify-center h-5 ${isSafari ? 'w-12' : (localStorage.getItem('defaultI18n') === 'ja' || localStorage.getItem('defaultI18n') === 'ko') ? 'w-12' : localStorage.getItem('defaultI18n') === 'zh' ? 'w-10' : 'w-8'} after:content-[""] after:absolute after:h-10 after:top-5 after:w-20 after:-left-5`}>
                                    <div onMouseEnter={() => { setOpenLang(true) }} className='relative flex flex-row items-center justify-end gap-[0.15rem] cursor-pointer '>
                                        <span className='text-[rgba(255,255,255,0.5)] [transition:all_0.2s_ease] group-hover:text-[rgba(255,255,255,1)] ' >{localStorage.getItem('defaultI18n') ? LangMap.filter(lang => lang.lang === localStorage.getItem('defaultI18n'))[0].name : 'EN'}</span>
                                    </div>
                                    <div onMouseLeave={() => { setOpenLang(false) }} className={`absolute z-[201] transition-300-ease bg-[rgba(rgba(0,0,0,0.2))] overflow-hidden rounded-xl top-10 -left-5 flex flex-col justify-start items-start backdrop-blur-xl before:[-webkit-mask-image:linear-gradient(red,red),linear-gradient(red,red)] before:[-webkit-mask-clip:padding-box,content-box] before:absolute before:z-[-10] before:box-border before:content-[""] before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:block before:[border-radius:inherit] before:p-px before:bg-[linear-gradient(136deg,_rgba(255,_255,_255,_0.5)_0%,_rgba(255,_255,_255,_0.18)_49.19%,_rgba(255,_255,_255,_0.5)_100%)] before:bg-clip-padding before:[mask-composite:exclude]  ${openLang ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                                        {LangMap.map((item, index) => {
                                            return (
                                                <div onClick={() => switchLang(item.lang)} key={index} className={`flex items-center justify-center group/lang transition-300-ease px-4 ${index === 0 && "pt-5 pb-3.5"} py-3.5 ${index === 4 && "pb-5 pt-3.5"} flex-row gap-2.5 flex-1 items-start w-full text-[14px] cursor-pointer hover:bg-[rgba(255,_255,_255,_0.1)]`}>
                                                    <span className={`font-[Arial] whitespace-nowrap [transition:all_0.3s_ease] text-[16px] font-normal leading-[18.4px] text-[rgba(255,_255,_255,_0.5)] group-hover/lang:text-[rgba(255,_255,_255,_0.8)] `}>{item.name}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>

                            </Restricted>
                        </div>
                    </Sentry.ErrorBoundary>
                </div>
            </header>

            {showHistory && <HistoryPopup wallet={{
                group: userPermission.chatavatar_tab_group,
                groupInitial: openPaymentInfo.group,
                userInitial: !openPaymentInfo.group
            }} />}
        </>
    );
}

export default React.memo(Header)
